import { getCookie } from '../utils/CookiesUtil';
import api from "./apiMethods";

const { REACT_APP_API_URL } = process.env;

export const getLots = async () => {

  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-collect-batchs`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getColletedLots = async () => {

  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-collect-batches-assigned-collected`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getLotsBySuperadmin = async (zoneIds = null) => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-collect-batchs`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  // Solo agregar data/body si zoneIds tiene valor
  if (zoneIds && Array.isArray(zoneIds) && zoneIds.length > 0) {
    const payload = { zones: zoneIds };
    request.data = payload;
    request.body = JSON.stringify(payload);
  }

  return api(request);
};

export const getColletedLotsBySuperadmin = async (zoneIds = null) => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-collect-batches-assigned-collected`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  // Solo agregar data/body si zoneIds tiene valor
  if (zoneIds && Array.isArray(zoneIds) && zoneIds.length > 0) {
    const payload = { zones: zoneIds };
    request.data = payload;
    request.body = JSON.stringify(payload);
  }

  return api(request);
};

export const assignLotsToDeliveryMan = async (idDeliveryMan, idsLots) => {
  
  const payload = {
    id_delivery_man: idDeliveryMan,
    batches_list: idsLots,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/assing-batch-to-delivery-man`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const assignLotsLocation = async (idLot, latitude, longitude) => { 
  
  const payload = {
    location_type: "business",
    id_location: idLot,
    latitude: latitude,
    longitude: longitude,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/update-lat-long-coordinates`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};